import React from "react";
import OpcionDefecto from "../../../../Common/Components/OpcionDefecto";
import CheckDefecto from "../../../../Common/Components/CheckDefecto";
import ExpHelper from '../../../../Common/Helpers/ExpHelper';

const Carteras = ({ data, selectCheckBox, selectCombo, titulo, textValidacion }) => {
    const { GET_CARTERAS, selectedAdministrator } = data;
    const arrayAux = GET_CARTERAS.filter(d => d.Checked);
    let acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o")
    let administradora =selectedAdministrator
    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{titulo}</label>
                {GET_CARTERAS.map((item) => {
                    const referencia = `GC-${item.Id}`;
                    return (
                        (item.Activo || item.noDisponible )&& <CheckDefecto
                            key={item.Id}
                            nombre={item.Descripcion}
                            check={item.Checked}
                            activo={item.Activo}
                            referencia={referencia}
                            selectCheckBox={() => selectCheckBox("GET_CARTERAS", item.Id)} />
                    )

                })}

                <OpcionDefecto
                    selecciono={arrayAux.length}
                    infoData={arrayAux}
                    referencia={"CarteraDefaultId"}
                    valorCombo={data.CarteraDefaultId}
                    valorChecked={data.CarteraDefaultInterfaz}
                    selectCombo={(value) => selectCombo("CarteraDefaultId", value)}
                    selectCheckBox={(value) => selectCheckBox("CarteraDefaultInterfaz", value)}
                />

                {(!data.ERROR_PRODUCT["seleccionoCartera"] && arrayAux.length === 0) &&                                   
                    (administradora=="V"?<label className="error">{"Debe seleccionar al menos una Cartera."}</label>:
                     <label className="error">{"Debe seleccionar al menos un ciclo de facturaci" + acentoLetraOminuscula + "n."}</label>
                    )
                }

            </div>
        </div>
    );
}

export default Carteras;